import { FormUsers } from "../components/FormUsers";

export const CreateUser: React.FC = () => {
  return (
    <div>
      <FormUsers pageType="create" />
    </div>
  );
};